var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCertificateFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My Certificate"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -296,
    width: 360,
    height: 800,
    rx: 12,
    fill: "#021239"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973353300"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 514",
    opacity: 0.06,
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#DEE1FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973353299"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10967",
    x: 43.0156,
    y: 51.2344,
    width: 73.9688,
    height: 57.5312,
    rx: 6.575,
    fill: "#2E406F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M76.9505 84.6094H52.5843C52.0236 84.6094 51.5691 85.0639 51.5691 85.6246C51.5691 86.1853 52.0236 86.6399 52.5843 86.6399H76.9505C77.5112 86.6399 77.9658 86.1853 77.9658 85.6246C77.9658 85.0639 77.5112 84.6094 76.9505 84.6094Z",
    fill: "#021239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M101.607 77.8359H52.5843C52.0236 77.8359 51.5691 78.2905 51.5691 78.8512C51.5691 79.4119 52.0236 79.8665 52.5843 79.8665H101.607C102.167 79.8665 102.622 79.4119 102.622 78.8512C102.622 78.2905 102.167 77.8359 101.607 77.8359Z",
    fill: "#021239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M101.607 71.0703H52.5843C52.0236 71.0703 51.5691 71.5249 51.5691 72.0856C51.5691 72.6463 52.0236 73.1008 52.5843 73.1008H101.607C102.167 73.1008 102.622 72.6463 102.622 72.0856C102.622 71.5249 102.167 71.0703 101.607 71.0703Z",
    fill: "#021239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M108.588 93.6798C108.547 93.2466 108.141 92.9353 107.708 93.0233C106.517 93.2737 105.407 93.8084 104.52 94.2551C104.452 94.2551 104.452 94.3228 104.385 94.3228C104.723 93.3076 104.52 92.563 103.911 92.1569C102.693 91.4124 99.9853 92.9015 97.6163 94.7289C97.5486 94.5935 97.481 94.5259 97.4133 94.4582C96.8718 93.8558 95.7889 93.3549 93.9749 94.316C93.5959 94.5191 93.4741 95.0132 93.7177 95.3719C93.9276 95.6833 94.3337 95.7848 94.6653 95.6156C95.2609 95.3042 95.9852 95.0741 96.3303 95.4802C96.398 95.5479 96.398 95.6156 96.4657 95.6833C95.4504 96.6308 94.5029 97.5107 93.9614 98.1876C92.9461 99.4736 92.54 100.76 92.9461 101.775C93.1492 102.452 93.7584 102.858 94.4352 102.993H94.7059C95.4504 102.993 96.2627 102.587 96.8041 101.842C97.684 100.651 98.3879 98.4041 98.2119 96.5699C98.1849 96.3127 98.2796 96.0555 98.4827 95.8998C100.418 94.404 102.456 93.3211 103.092 93.382C103.092 93.5174 103.024 93.8558 102.754 94.5326C102.618 94.8034 102.347 95.4802 102.821 95.954C103.363 96.4955 104.04 96.157 105.122 95.6156C105.908 95.2772 106.977 94.7492 108.019 94.5056C108.378 94.4243 108.615 94.0927 108.581 93.7272V93.6866L108.588 93.6798ZM95.5249 100.956C95.1188 101.43 94.7804 101.497 94.5096 101.497C94.3743 101.497 94.2389 101.362 94.1712 101.227C94.0359 100.888 94.1712 100.144 94.9834 99.1284C95.4572 98.5192 96.0664 97.9101 96.6078 97.4363C96.5402 98.6546 96.2017 100.144 95.5249 100.956Z",
    fill: "#021239"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2323",
    cx: 54.7518,
    cy: 61.9379,
    r: 3.12537,
    fill: "#021239"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCertificateFound);
export default __webpack_public_path__ + "static/media/no-certificate-found.e18e24e40449009380b5f6f38bcc4126.svg";
export { ForwardRef as ReactComponent };